<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Tipos de cambio" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<CommonButtonCompanyAdminSettingOption />
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.home' }" :submitting="submitting" :errors="validationExternal" @submit="submit" v-if="!loading">
				<template #body>
					<CommonFormInputCustomExchange v-model:exchanges="form.exchanges" title="Establecer los tipos de cambio" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, onMounted } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminExchangeRepository from '@/repositories/modules/Company/Admin/Exchange';

	export default {
		setup() {
			const { loading, submitting, validationExternal, catchError } = composableForm();

			const form = reactive({
				exchanges: []
			});

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];

				submitting.value = true;
				await CompanyAdminExchangeRepository.store(form).then((response) => {
					router.push({ name: 'company.admin.home' });
				}).catch(catchError);
				submitting.value = false;
			}

			onMounted(async () => {
				await CompanyAdminExchangeRepository.list().then((response) => {
					form.exchanges = response.data;
				}).catch((e) => catchError(e, true));

				loading.value = false;
			});

			return { loading, form, submit, submitting, validationExternal };
		}
	}
</script>